import { render, staticRenderFns } from "./DynamicStatistics.vue?vue&type=template&id=b255c294&scoped=true"
import script from "./DynamicStatistics.vue?vue&type=script&lang=js"
export * from "./DynamicStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b255c294",
  null
  
)

export default component.exports